import Vue from 'vue'
import ImageDialog from '../view/common/ChooseImage.vue'
import router from '../router/index';
const ImageDialogBox = Vue.extend(ImageDialog);

ImageDialog.install = function (data) {
    let instance = new ImageDialogBox({
        router,
        data
    }).$mount();

    document.body.appendChild(instance.$el);

    Vue.nextTick(() => {
        instance.dialogVisible = true
    });

};

export default ImageDialog